export const cilLineSpacing = ["24 24","<path d='M11.25 2.25h12v1.5h-12v-1.5z'></path><path d='M11.25 8.25h12v1.5h-12v-1.5z'></path><path d='M11.25 14.25h12v1.5h-12v-1.5z'></path><path d='M11.25 20.25h12v1.5h-12v-1.5z'></path><path d='M1.125 5.34v1.41h3.337v10.5h-3.337v1.415l4.169 4.581 4.081-4.586v-1.41h-3.413v-10.5h3.413v-1.415l-4.169-4.581zM5.281 21.004l-2.051-2.254h4.057zM7.27 5.25h-4.057l2.006-2.254z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-line-spacing.js
// module id = null
// module chunks = 